import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDAvatar from '../../../../BaseComponents/Avatar/EDAvatar';
import EDOverlay from '../../../../BaseComponents/Overlay/EDOverlay';
import EDTooltip from '../../../../BaseComponents/Tooltip/EDTooltip';
import EDIcon from '../../../../BaseComponents/Icon/EDIcon';
import EDIconButton from '../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import { IMessage } from '../../../Messages/Messages';

interface IProps {
  messages: IMessage[];
  small?: boolean;
  pinned?: boolean;
  togglePinned: () => void;
  disabled?: boolean;
  disabledReason?: string;
  classes?: any;
}

const styles = (theme: Theme) => ({
  avatarColor: {
    background: theme.customProperties.Warning.light,
    '&:hover': {
      background: theme.customProperties.Warning.main,
    },
  },
  notificationOverlay: {
    bottom: 8,
    right: 8,
  },
  smallNotificationOverlay: {
    bottom: -8,
    right: -8,
  },
  notificationIcon: {
    width: '20px',
    height: '20px',
    fontSize: theme.typography.pxToRem(12),
  },
  disabledButton: {
    '&:disabled': {
      color: theme.palette.action.disabled,
    },
  },
});

/**
 * En knapp för att öppna TaskMenu. Visar overlay över antal olästa meddelanden som återfinns i meddelande tabben.
 */
export const TaskMenuButtonBase: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { messages, pinned, togglePinned, disabled, disabledReason } = props;

  const nrNotifications = messages.filter(
    message => !message.reciever.read
  ).length;

  const avatar = (
    <EDAvatar
      className={props.classes.notificationIcon}
      classes={{
        colorDefault: props.classes.avatarColor,
      }}
      disabled={props.disabled}
    >
      {nrNotifications}
    </EDAvatar>
  );

  if (pinned) {
    return (
      <EDOverlay
        overlay={
          nrNotifications > 0 && (
            <EDTooltip title={`${nrNotifications} olästa meddelanden`}>
              {avatar}
            </EDTooltip>
          )
        }
        classes={{
          overlay: props.small
            ? props.classes.smallNotificationOverlay
            : props.classes.notificationOverlay,
        }}
      >
        <EDIcon
          margin={!props.small ? 0.5 : undefined}
          marginLeft={!props.small ? 0 : undefined}
          padding={!props.small ? 1.5 : undefined}
          color={props.small ? 'secondary' : 'inherit'}
          iconType="assignment"
          size="medium"
        />
      </EDOverlay>
    );
  } else {
    return (
      <EDOverlay
        overlay={
          nrNotifications > 0 && (
            <EDIconButton
              tooltip={!disabled ? `${nrNotifications} olästa meddelanden` : ''}
              onClick={togglePinned}
              icon={avatar}
              padding="none"
              margin="none"
              disabled={disabled}
            />
          )
        }
        classes={{ overlay: props.classes.notificationOverlay }}
      >
        <EDIconButton
          tooltip=""
          color="inherit"
          onClick={togglePinned}
          margin="dense"
          icon={<EDIcon iconType="assignment" color="inherit" size="medium" />}
          className={props.classes.disabledButton}
          disabled={disabled}
          disabledReason={disabledReason}
          noLeftMargin
          noTopMargin
          noBottomMargin
        />
      </EDOverlay>
    );
  }
};

export const TaskMenuButton = withStyles(TaskMenuButtonBase, styles);
